module.exports = __webpack_public_path__ + "static/media/phone.8ba5559d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/phone.svg
// module id = 81
// module chunks = 0